import { securityAuthenticationResetPasswordPostAsyncSlice } from './post';

export const {
	requestPostSecurityAuthenticationResetPassword,
	resetPostSecurityAuthenticationResetPassword
} = securityAuthenticationResetPasswordPostAsyncSlice.asyncActionCreators;
